import { createAction } from "redux-actions";

import { parseApiError } from "@/utils/parseApiError";

export const tokenInject = (fn) => (dispatch, getState) => {
  const localStorageAuth = window.localStorage.getItem("auth");
  return fn(dispatch, getState, JSON.parse(localStorageAuth));
};

const thunkAction = (actionName, actionMethod, emitPending = false, autoPending = true) => {
  const fulfilledAction = createAction(`${actionName} fulfilled`);
  const rejectedAction = createAction(`${actionName} rejected`);
  let pendingAction;
  if (emitPending) {
    if (typeof emitPending !== "function") {
      pendingAction = createAction(`${actionName} pending`, (payload) => payload);
    } else {
      pendingAction = createAction(`${actionName} pending`, emitPending);
    }
  }

  return (...args) =>
    tokenInject((dispatch, getState, token) => {
      const fulfilled = (...fArgs) => {
        dispatch(fulfilledAction(...fArgs));
        emitPending &&
          autoPending &&
          dispatch(pendingAction({ isPending: false, success: true }, ...args));
      };

      const rejected = (errors) => {
        const parsed = errors ? parseApiError(errors) : null;
        // A 401 here is deliberately NOT a logout. The axios interceptor owns
        // the session: it refreshes the access token, retries, and only tears
        // the session down when the refresh itself is definitively rejected.
        // Logging out here bypassed that entirely — and logout() POSTs
        // revoke_token/, so a single transient 401 (or the second 401 of a
        // retried request, which the interceptor deliberately lets through)
        // revoked the refresh token server-side and killed the session in
        // every open tab, with no refresh ever attempted.
        if (errors && !errors.response) {
          console.error(errors);
        }

        dispatch(rejectedAction(parsed?.message));
        emitPending &&
          autoPending &&
          dispatch(pendingAction({ isPending: false, success: false }, errors));
      };

      emitPending &&
        autoPending &&
        dispatch(pendingAction({ isPending: true, success: false }, ...args));

      const result = actionMethod(
        {
          dispatch,
          getState,
          token,
          pendingAction,
          fulfilled,
          rejected,
        },
        ...args
      );
      if (result instanceof Promise) {
        result.catch(rejected);
      }
      return result;
    });
};

export default thunkAction;
